module.exports = __webpack_public_path__ + "img/screen_mode.a8c3ea31.png";